/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForOci extends models.ServiceAccountCredentialsBaseForOci {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForOci");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForOci.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForOci>): ServiceAccountCredentialsForOci {
        let obj = Object.assign(new ServiceAccountCredentialsForOci(), model);
        ServiceAccountCredentialsForOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForOci>): ServiceAccountCredentialsForOci {
        if (!model) return null;
        return ServiceAccountCredentialsForOci.newInstance(<ServiceAccountCredentialsForOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForOci) {
        if (!obj) return;

        models.ServiceAccountCredentialsForOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForOci): boolean {
        if (models.ServiceAccountCredentialsBaseForOci.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Auth User Id. This is a required field.
     */
    user: string;

    /**
     * Key Fingerprint. This is a required field.
     */
    fingerprint: string;

    /**
     * Private Key. This is a required field.
     */
    private_key: string;

}
